import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { rename } from "reduxSlices/SAMLConfigurationsSlice"
import { SAMLConfigurationShape } from "utils/propTypeShapes"
import { canonicalName, scrubEnteredNameValue } from "utils/SAMLConfigurationHelpers"
import { PrimaryButton } from "shared/buttons"
import { TextInput } from "shared/inputs"
import SAMLConfigurationsListItemSection from "./SAMLConfigurationsListItemSection"

const SAMLConfigurationsListItemNameSection = ({ configuration }) => {
  const dispatch = useDispatch()
  const { id, name: currentName } = configuration
  const [rawName, setRawName] = useState(canonicalName(currentName))

  useEffect(() => {
    setRawName(canonicalName(currentName))
  }, [currentName])

  const newName = canonicalName(rawName)

  const updateRawName = (value) => {
    setRawName(scrubEnteredNameValue(value))
  }

  const update = (event) => {
    event.preventDefault()
    if (!newName) return

    dispatch(rename({ id, name: newName }))
  }

  const formId = `rename-saml-configuration-form-${id}`

  return (
    <SAMLConfigurationsListItemSection title="SAML Configuration Name">
      <div className="flex flex-col gap-8 sm:gap-4 w-full">
        <form id={formId} className="flex flex-col sm:flex-row gap-4 w-full" onSubmit={update}>
          <TextInput className="grow bordered-base-input !bg-white" onChange={updateRawName} value={rawName} />
          <PrimaryButton
            disabled={!newName || newName === currentName}
            form={formId}
            text="Save"
            type="submit"
          />
        </form>
        <p className="text-xs text-dark">
          The SAML configuration name will be displayed to users on the sign-in page
          to help them select the correct identity provider.
        </p>
      </div>
    </SAMLConfigurationsListItemSection>
  )
}

SAMLConfigurationsListItemNameSection.propTypes = {
  configuration: SAMLConfigurationShape.isRequired,
}

export default SAMLConfigurationsListItemNameSection
